<section class="pt-0 pb-0">
    <ngx-spinner></ngx-spinner>

<section class="casestudy-no-bg news-page mt-100 main-container-div pb-280" id="scrollingToTop">
    <div class="container">
        <div class="inner-container">
            <h2 class="page-title mb-4">News Feed</h2>

            <div class="row news-row">

                <div class="col-md-6 news-col" *ngFor="let data of news; let isOdd=odd">
                    <div class="wrap h-100 hide-on-init" animateOnScroll animationName="animated fadeIn">
                        <ng-container *ngTemplateOutlet="viewTemplate;context:{newsData:data}"></ng-container>
                    </div>
                    <!-- <ng-container *ngIf="isOdd; else evenBlock">
                        <div class="wrap h-100 hide-on-init" animateOnScroll animationName="animated fadeInRight">
                            <ng-container *ngTemplateOutlet="viewTemplate;context:{newsData:data}"></ng-container>
                        </div>
                    </ng-container>
                    <ng-template #evenBlock>
                        <div class="wrap h-100 hide-on-init" animateOnScroll animationName="animated fadeInLeft">
                            <ng-container *ngTemplateOutlet="viewTemplate;context:{newsData:data}"></ng-container>
                        </div>
                    </ng-template> -->
                </div><!-- news-col end -->
                <ng-template #viewTemplate let-data="newsData">
                    <div (click)="newsLinkClick(data)">
                    <a [attr.href]="data.link" target="_blank">
                    <div class="npost-img" *ngIf="data.image">
                        <img src="assets/img/news/newspost-img.jpg" alt="">
                    </div>
                    <h3>{{data?.title}}</h3>
                    <small *ngIf="data?.publish_date">
                        {{data?.publish_date  | date:'d MMM y,EEEE'}}
                    </small>
                    <!-- hh:mm a on  -->
                    <div class="news-content">
                        <p [innerHtml]="transform(data?.description)"><br></p>
                        <div class="row">
                            <div class="col-6">
                                <p class="news-editor mb-0"><strong>{{data?.channelName}}</strong></p>
                            </div>
                            <div class="col-6 text-right">
                                <a [attr.href]="data.link" target="_blank">read more</a>
                                <!-- <a href="javascript:;">read more</a> -->

                            </div>
                        </div>
                    </div>
                </a>
            </div>
                </ng-template>
            </div><!-- news-row end -->
            <div class="row pagination-row mt-5 mb-0" [hidden]="!showPagination">
                <div class="col-md-12 text-right">
                  <div class="pagination justify-content-end">
                      <div class="page-item">
                        <pagination [boundaryLinks]="true" [itemsPerPage]="itemsPerPage" [totalItems]="totalItems" [(ngModel)]="page" (pageChanged)="pageChanged($event)"
                        [customPreviousTemplate]="prevTemplate"
                        [maxSize]="maxSize"
                    [customNextTemplate]="nextTemplate"
                    [customFirstTemplate]="firstTemplate"
                    [customLastTemplate]="lastTemplate"
                        [ngClass]="(totalPages == page) ? 'my-pagination' : ''"></pagination>
                        <ng-template #nextTemplate let-disabled="disabled" let-currentPage="currentPage">
                          <ng-container *ngIf="!disabled">
                            Next
                          </ng-container>
                        </ng-template>

                        <ng-template #prevTemplate let-disabled="disabled" let-currentPage="currentPage">
                          <ng-container *ngIf="!disabled">
                            Previous
                          </ng-container>
                        </ng-template>

              <ng-template #lastTemplate let-disabled="disabled" let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                Last
                </ng-container>
              </ng-template>
               
              <ng-template #firstTemplate let-disabled="disabled" let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                First
                </ng-container>
              </ng-template>
                      </div>
                    </div>
                </div>
              </div>

        </div>
    </div>
</section>
</section>
